import { Component, OnInit } from '@angular/core';
import {WidgetBaseComponent} from '../widget-base/widget-base.component';
import {DoraProperty} from '../../Decorators/Decorator';
import {MessageSeriesFixedEnabled} from '../../messages/message-series-fixed-enabled';
import {MessageDataFixedAvaiable} from '../../messages/message-data-fixed-avaiable';
import {MessageSeriesTypeSelected} from '../../messages/message-series-type-selected';

@Component({
  selector: 'dora-series-fixed',
  templateUrl: './dora-series-fixed.component.html',
  styleUrls: ['./dora-series-fixed.component.scss']
})
export class DoraSeriesFixedComponent extends WidgetBaseComponent {
  @DoraProperty
  private label = 'FIXED_SERIES';

  protected chekBoxSelected = false;

  protected fixedDataAvaiable = false;
  protected dateRangeFull = true;

  onParameterInjectedFinished() {
    super.onParameterInjectedFinished();

    this.messageService.getMessage(this.EventChannel, MessageDataFixedAvaiable, this.CallerName).subscribe(doraMessage => {
      this.fixedDataAvaiable = (doraMessage.data as MessageDataFixedAvaiable).isAvaiable;
    });

    this.messageService.getMessage(this.EventChannel, MessageSeriesTypeSelected, this.CallerName).subscribe(doraMessage => {
      const dateRange = (doraMessage.data as MessageSeriesTypeSelected).seriesSelectorType.dateRange;

      if (dateRange === null || dateRange === undefined) {
        this.dateRangeFull = true;
      } else {
        this.dateRangeFull = false;
      }

    });
    this.sendEvent();
  }

  onSelectorChange() {
    this.chekBoxSelected = !this.chekBoxSelected;
    this.sendEvent();
  }

  getLabel() {
    return this.translationService.get(this.label);
  }
  private sendEvent() {
    this.messageService.sendMessage(this.EventChannel, new MessageSeriesFixedEnabled(this.chekBoxSelected), this.CallerName);
  }

  getGlobalCssClass(): string {
    let cssClass = 'DAG-Series-Fixed';

    if (this.fixedDataAvaiable && this.dateRangeFull) {
      cssClass += ' enabled';
    } else {
      cssClass += ' disabled';
    }
    return cssClass;
  }
}
